module.exports = __webpack_public_path__ + "1df7d6a521cbbd04fbaa5c1ff677e131.png";